import { object, ref, string } from 'yup'

import { validateField, validateValues } from 'shared/utils/form'
import { isNilOrEmpty } from 'shared/utils/ramda'

type PostalCodeValues = {
  postalCode: string
}

export const postalCodeSchema = object().shape({
  postalCode: string().test(
    'is-present',
    'Kod pocztowy jest wymagany',
    function (value) {
      const { path, createError } = this
      const phoneNumber = this.resolve(ref(path))

      if (isNilOrEmpty(phoneNumber)) return true
      if (value && !/\d{2}-\d{3}/.test(value)) {
        return createError({ path, message: 'Nieprawidłowy format' })
      }

      return true
    }
  )
})

export const validatePostalCodeField = (values: PostalCodeValues) =>
  validateField(postalCodeSchema, values)
export const validatePostalCodeValues = validateValues(postalCodeSchema)

export const autoCompletePostalCode = (value: string) => {
  let inputValue = value.replace(/\s/g, '').replace(/[^0-9-]/g, '')

  if (inputValue.startsWith('-')) {
    inputValue = inputValue.slice(1)
  } else if (inputValue[1] === '-') {
    inputValue = inputValue.slice(0, 1)
  } else if (inputValue[3] === '-') {
    inputValue = inputValue.slice(0, 3)
  } else if (inputValue[4] === '-') {
    inputValue = inputValue.slice(0, 4)
  } else if (inputValue[5] === '-') {
    inputValue = inputValue.slice(0, 5)
  }

  if (inputValue.length >= 3 && inputValue.charAt(2) !== '-') {
    inputValue = inputValue.slice(0, 2) + '-' + inputValue.slice(2)
  }
  inputValue = inputValue.slice(0, 6)

  return inputValue
}
